import React from 'react';
import { Box, List, Typography } from '@mui/material';
import MainPetsAgendaListItem from './MainPetsAgendaListItem';
import { useTranslation } from 'react-i18next';

const MainPetsAgendaList = ({agendaItems, onClick, onPostpone, onComplete, onEventClick, config}) => {
  const { t } = useTranslation();
  return (
    <Box 
      sx={{ 
        width: '100%', 
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: 'background.paper',
        mb: 2
      }}>
        <Typography 
          variant="caption" 
          noWrap 
          sx={{ 
            ml: 2,
            mt: 4,
          }}
        >
          {t('agenda.inAgenda')}
        </Typography>

        <List>
          {agendaItems.map((item) => (
            <MainPetsAgendaListItem
              key={item.id}
              item={item}
              onClick={onClick}
              onEventClick={onEventClick}
              onPostpone={onPostpone}
              onComplete={onComplete}
              config={config}
            />
          ))}
        </List>
      </Box>
  );
};

export default MainPetsAgendaList; 